export const NAV_BAR_TOGGLE = 'petdata/NAV_BAR_TOGGLE';
export const NAV_BAR_CLOSE = 'petdata/NAV_BAR_CLOSE';
export const NAV_BAR_TRANSITIONED = 'petdata/NAV_BAR_TRANSITIONED';

export const SHOW_SELECT_STORE_MODAL = 'petdata/SHOW_SELECT_STORE_MODAL';
export const HIDE_SELECT_STORE_MODAL = 'petdata/HIDE_SELECT_STORE_MODAL';

export const SHOW_CHANGE_PASSWORD_MODAL = 'petdata/SHOW_CHANGE_PASSWORD_MODAL';
export const HIDE_CHANGE_PASSWORD_MODAL = 'petdata/HIDE_CHANGE_PASSWORD_MODAL';

export const SHOW_ERROR_MODAL = 'petdata/SHOW_ERROR_MODAL';
export const HIDE_ERROR_MODAL = 'petdata/HIDE_ERROR_MODAL';


/** WEBPACK FOOTER **
 ** ./src/modules/navbar/actionTypes.js
 **/